import {
  PP_TOKEN_GENERATE_START,
  PP_TOKEN_GENERATE_SUCCUSS,
  PP_TOKEN_GENERATE_FAIL,
  CLEAR_TOKEN_ERROR
} from "../store/types";

import { cloud_function_server_url } from "config";

import { getDateString, getRandomNumber } from "../functions/commonFunctions";

export const PPTokenGenerator = () => (dispatch) => {
  dispatch({ type: PP_TOKEN_GENERATE_START });
  const requestOptions = {
    method: "GET",
    redirect: "follow"
  };
  try {
    fetch(`${cloud_function_server_url}/PPTokenGenerator`, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json(); // or response.text()
      })
      .then((TokenObject) => {
        dispatch({ type: PP_TOKEN_GENERATE_SUCCUSS, payload: TokenObject });
      })
      .catch((error) => {
        dispatch({
          type: PP_TOKEN_GENERATE_FAIL,
          payload: error.message || "Unknown error occurred"
        });
      });
  } catch (error) {
    dispatch({
      type: PP_TOKEN_GENERATE_FAIL,
      payload: error.message || "Unknown error occurred"
    });
  }
};

export const PPClearTokenError = () => (dispatch) => {
  dispatch({ type: CLEAR_TOKEN_ERROR, payload: null });
};
